import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransferTemplatesPage, { getDefaultUI } from "components/pages/TransferTemplatesPage";
import Classes from "model";

/**
 * @name CaptureTransferTemplatesMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureTransferTemplatesMainTemplate01(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "Accordion_0", "isActive" ], true)
    .submit();

    return <TransferTemplatesPage ui={ ui } />;
}